import React from 'react';
import { FDPaper, FDStack } from '@facet-wealth/design';
import { metaOverrideSet } from 'Views/Page/Content/Templates/LinkingAttemptsTemplate/LeftPanel/metaOverrideSet';
import CollectionQueryForm from 'Components/ComponentLibrary/Molecules/CollectionQueryForm';
import fr from 'facet-rest';

const ActivityFilters = ({ collection }) => {
  return (
    <FDPaper appearance={'outlined'}>
      <FDStack height={50} width={'100%'} alignItems={'center'} justifyContent={'center'}>
        <CollectionQueryForm
          collection={collection}
          metaOverrideSet={metaOverrideSet}
          onSubmit={(/* searchResultCollection */) => {
            // setPageContentCollection(searchResultCollection);
          }}
        />
      </FDStack>
    </FDPaper>
  );
};

ActivityFilters.defaultProps = {};

ActivityFilters.propTypes = {
  collection: fr.Collection.isRequired,
};

export { ActivityFilters };
